import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.list-credit-card-items.views.CreditCardItemTable`

export default defineMessages({
  tableAriaLabel: {
    id: `${scope}.tableAriaLabel`,
    defaultMessage: 'Credit card items',
  },
  refColumnLabel: {
    id: `${scope}.refColumnLabel`,
    defaultMessage: 'Ref.',
  },
  poTag: {
    id: `${scope}.poTag`,
    defaultMessage: 'PO',
  },
  rfeTag: {
    id: `${scope}.rfeTag`,
    defaultMessage: 'RFE',
  },
  dateColumnLabel: {
    id: `${scope}.dateColumnLabel`,
    defaultMessage: 'Date',
  },
  descriptionColumnLabel: {
    id: `${scope}.descriptionColumnLabel`,
    defaultMessage: 'Description',
  },
  accountCodeColumnLabel: {
    id: `${scope}.accountCodeColumnLabel`,
    defaultMessage: 'Account code',
  },
  totalCostColumnLabel: {
    id: `${scope}.totalCostColumnLabel`,
    defaultMessage: 'Total cost',
  },
  emptyStateText: {
    id: `${scope}.emptyStateText`,
    defaultMessage: 'There are no items',
  },
  unableToMoveTooltip: {
    id: `${scope}.unableToMoveTooltip`,
    defaultMessage:
      'Unable to move this item — it is matched or shares a paid purchase order',
  },
  selectItemAriaLabel: {
    id: `${scope}.selectItemAriaLabel`,
    defaultMessage: 'Select {description}',
  },
})
